
<div class="d-flex flex-column container align-items-center justify-content-center gap-2">
    <div class="d-md-flex flex-row align-items-center justify-content-center gap-2">
        <mat-card style="width: 28rem;">
            <img matCardImage src="{{img}}" class="card-img-top" alt="...">
        </mat-card>
        <div>
            <h2 class="mt-2">{{pokemonName}}</h2>
            <p>Height: {{height}}<br> Weight: {{weight}}</p>
            <mat-chip-list>Types: 
                <mat-chip *ngFor="let type of types" class="bg-pokemonType-{{type.type.name}} text-white" >{{type.type.name}}</mat-chip>
            </mat-chip-list>
        </div>
    </div>
        <div class="my-2 d-flex flex-wrap gap-2">
            <div *ngFor="let sprite of sprites">
                <mat-card *ngIf='sprite != null '>
                    <img src="{{sprite}}" alt=""  matCardImage onerror="this.remove();" >
                </mat-card>
            </div>
        </div>
    <a class="btn btn-primary w-100 my-2" [routerLink]="['/home']" routerLinkActive="router-link-active" >back</a>
</div>